import React from 'react'

export default function Loading() {
  return (
    <div className="loading-wrap">
      <div className="loading"></div>
    </div>
  )
}
